import { render, staticRenderFns } from "./navbarPC.vue?vue&type=template&id=1d9145f7&scoped=true"
import script from "./navbarPC.vue?vue&type=script&lang=js"
export * from "./navbarPC.vue?vue&type=script&lang=js"
import style0 from "./navbarPC.vue?vue&type=style&index=0&id=1d9145f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9145f7",
  null
  
)

export default component.exports